<div class="fs-2 danger with-close" mat-dialog-title>
    Echec de paiement
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <b>Une erreur est survenue lors de votre paiement. Votre abonnement n’a pas été validé.</b>
    <br/>
    <p class="text-center mt-4 mb-4">
        <img src="assets/error.png">
    </p>
    <p class="mb-0">Vous pouvez modifier votre moyen de paiement et relancer une nouvelle tentative pour pouvoir accéder à LyBox</p>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Fermer
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        Modifier mon moyen de paiement
    </button>
</div>
